import debug from 'debug';

const log = debug('Spinner:Templates');

class Templates {
	icon() {
		return `<svg class="a-spinner__icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
				<g transform="rotate(0 50 50)">
				<rect x="46.5" y="10.5" rx="3.5" ry="3.5" width="7" height="25"  >
					<animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1.6666666666666667s" begin="-1.5s" repeatCount="indefinite"></animate>
				</rect>
				</g><g transform="rotate(36 50 50)">
				<rect x="46.5" y="10.5" rx="3.5" ry="3.5" width="7" height="25"  >
					<animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1.6666666666666667s" begin="-1.3333333333333333s" repeatCount="indefinite"></animate>
				</rect>
				</g><g transform="rotate(72 50 50)">
				<rect x="46.5" y="10.5" rx="3.5" ry="3.5" width="7" height="25"  >
					<animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1.6666666666666667s" begin="-1.1666666666666667s" repeatCount="indefinite"></animate>
				</rect>
				</g><g transform="rotate(108 50 50)">
				<rect x="46.5" y="10.5" rx="3.5" ry="3.5" width="7" height="25"  >
					<animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1.6666666666666667s" begin="-1s" repeatCount="indefinite"></animate>
				</rect>
				</g><g transform="rotate(144 50 50)">
				<rect x="46.5" y="10.5" rx="3.5" ry="3.5" width="7" height="25"  >
					<animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1.6666666666666667s" begin="-0.8333333333333334s" repeatCount="indefinite"></animate>
				</rect>
				</g><g transform="rotate(180 50 50)">
				<rect x="46.5" y="10.5" rx="3.5" ry="3.5" width="7" height="25"  >
					<animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1.6666666666666667s" begin="-0.6666666666666666s" repeatCount="indefinite"></animate>
				</rect>
				</g><g transform="rotate(216 50 50)">
				<rect x="46.5" y="10.5" rx="3.5" ry="3.5" width="7" height="25"  >
					<animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1.6666666666666667s" begin="-0.5s" repeatCount="indefinite"></animate>
				</rect>
				</g><g transform="rotate(252 50 50)">
				<rect x="46.5" y="10.5" rx="3.5" ry="3.5" width="7" height="25"  >
					<animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1.6666666666666667s" begin="-0.3333333333333333s" repeatCount="indefinite"></animate>
				</rect>
				</g><g transform="rotate(288 50 50)">
				<rect x="46.5" y="10.5" rx="3.5" ry="3.5" width="7" height="25"  >
					<animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1.6666666666666667s" begin="-0.16666666666666666s" repeatCount="indefinite"></animate>
				</rect>
				</g><g transform="rotate(324 50 50)">
				<rect x="46.5" y="10.5" rx="3.5" ry="3.5" width="7" height="25"  >
					<animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1.6666666666666667s" begin="0s" repeatCount="indefinite"></animate>
				</rect>
				</g>
			</svg>`;
	}

	iconDef() {
		return `<svg class="a-spinner__icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
				<defs>
				<g id="spinner">
				<g transform="rotate(0 50 50)">
				<rect x="46.5" y="10.5" rx="3.5" ry="3.5" width="7" height="25"  >
					<animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1.6666666666666667s" begin="-1.5s" repeatCount="indefinite"></animate>
				</rect>
				</g><g transform="rotate(36 50 50)">
				<rect x="46.5" y="10.5" rx="3.5" ry="3.5" width="7" height="25"  >
					<animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1.6666666666666667s" begin="-1.3333333333333333s" repeatCount="indefinite"></animate>
				</rect>
				</g><g transform="rotate(72 50 50)">
				<rect x="46.5" y="10.5" rx="3.5" ry="3.5" width="7" height="25"  >
					<animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1.6666666666666667s" begin="-1.1666666666666667s" repeatCount="indefinite"></animate>
				</rect>
				</g><g transform="rotate(108 50 50)">
				<rect x="46.5" y="10.5" rx="3.5" ry="3.5" width="7" height="25"  >
					<animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1.6666666666666667s" begin="-1s" repeatCount="indefinite"></animate>
				</rect>
				</g><g transform="rotate(144 50 50)">
				<rect x="46.5" y="10.5" rx="3.5" ry="3.5" width="7" height="25"  >
					<animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1.6666666666666667s" begin="-0.8333333333333334s" repeatCount="indefinite"></animate>
				</rect>
				</g><g transform="rotate(180 50 50)">
				<rect x="46.5" y="10.5" rx="3.5" ry="3.5" width="7" height="25"  >
					<animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1.6666666666666667s" begin="-0.6666666666666666s" repeatCount="indefinite"></animate>
				</rect>
				</g><g transform="rotate(216 50 50)">
				<rect x="46.5" y="10.5" rx="3.5" ry="3.5" width="7" height="25"  >
					<animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1.6666666666666667s" begin="-0.5s" repeatCount="indefinite"></animate>
				</rect>
				</g><g transform="rotate(252 50 50)">
				<rect x="46.5" y="10.5" rx="3.5" ry="3.5" width="7" height="25"  >
					<animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1.6666666666666667s" begin="-0.3333333333333333s" repeatCount="indefinite"></animate>
				</rect>
				</g><g transform="rotate(288 50 50)">
				<rect x="46.5" y="10.5" rx="3.5" ry="3.5" width="7" height="25"  >
					<animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1.6666666666666667s" begin="-0.16666666666666666s" repeatCount="indefinite"></animate>
				</rect>
				</g><g transform="rotate(324 50 50)">
				<rect x="46.5" y="10.5" rx="3.5" ry="3.5" width="7" height="25"  >
					<animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1.6666666666666667s" begin="0s" repeatCount="indefinite"></animate>
				</rect>
				</g>
				</g>
				</defs>
			</svg>`;
	}

	svgDefsContainer() {
		return '<div class="visually-hidden" data-js="svg-defs-container"></div>';
	}

	/**
	 * @param {string} cssClass
	 * @returns {string} markup
	 */
	useIcon(cssClass) {
		return `<span class="a-spinner ${cssClass}"><svg class="a-spinner__icon" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><use class="a-spinner__icon-use" href="#spinner"/></svg></span>`;
	}
}

export default Templates;
